/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Pdf_Export_FailedInputs */

const en_resumes_pdf_export_failed = /** @type {(inputs: Resumes_Pdf_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF export failed. Ensure printer service is running.`)
};

const de_resumes_pdf_export_failed = /** @type {(inputs: Resumes_Pdf_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-Export fehlgeschlagen. Stelle sicher, dass der Druckdienst läuft.`)
};

const fr_resumes_pdf_export_failed = /** @type {(inputs: Resumes_Pdf_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'export PDF. Assure-toi que le service d'impression est actif.`)
};

const es_resumes_pdf_export_failed = /** @type {(inputs: Resumes_Pdf_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error en la exportación PDF. Asegúrese de que el servicio de impresión esté activo.`)
};

const it_resumes_pdf_export_failed = /** @type {(inputs: Resumes_Pdf_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione PDF non riuscita. Assicurati che il servizio di stampa sia in esecuzione.`)
};

const nl_resumes_pdf_export_failed = /** @type {(inputs: Resumes_Pdf_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-export mislukt. Zorg dat de printerservice actief is.`)
};

const pl_resumes_pdf_export_failed = /** @type {(inputs: Resumes_Pdf_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksport PDF nie powiódł się. Upewnij się, że usługa drukowania jest uruchomiona.`)
};

const fi_resumes_pdf_export_failed = /** @type {(inputs: Resumes_Pdf_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-vienti epäonnistui. Varmista, että tulostuspalvelu on käynnissä.`)
};

const da_resumes_pdf_export_failed = /** @type {(inputs: Resumes_Pdf_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-eksport mislykkedes. Sørg for at printerservicen kører.`)
};

const sv_resumes_pdf_export_failed = /** @type {(inputs: Resumes_Pdf_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-export misslyckades. Se till att utskriftstjänsten körs.`)
};

/**
* | output |
* | --- |
* | "PDF export failed. Ensure printer service is running." |
*
* @param {Resumes_Pdf_Export_FailedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_pdf_export_failed = /** @type {((inputs?: Resumes_Pdf_Export_FailedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Pdf_Export_FailedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_pdf_export_failed(inputs)
	if (locale === "fr") return fr_resumes_pdf_export_failed(inputs)
	if (locale === "es") return es_resumes_pdf_export_failed(inputs)
	if (locale === "it") return it_resumes_pdf_export_failed(inputs)
	if (locale === "nl") return nl_resumes_pdf_export_failed(inputs)
	if (locale === "pl") return pl_resumes_pdf_export_failed(inputs)
	if (locale === "fi") return fi_resumes_pdf_export_failed(inputs)
	if (locale === "da") return da_resumes_pdf_export_failed(inputs)
	if (locale === "sv") return sv_resumes_pdf_export_failed(inputs)
	return en_resumes_pdf_export_failed(inputs)
});